<template>
  <BModal
    active
    has-modal-card
    @close="onClose"
  >
    <div class="push-customer-searcher">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Buscar cliente por email
          </p>
        </header>
        <section class="modal-card-body">
          <SearcherByEmail @select="$router.push({ name: 'NewInvoice' })" />
        </section>
        <footer class="modal-card-foot">
          <RouterLink
            class="button"
            :to="{ name: 'NewInvoice' }"
          >
            Cerrar
          </RouterLink>
        </footer>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'PushCustomer',
  components: {
    SearcherByEmail: () => import('@/components/Admin/Customer/SearcherByEmail.vue'),
  },
  methods: {
    onClose() {
      this.$router.push({ name: 'NewInvoice' });
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 100%;
  height: 100%;
}

.push-customer-searcher {
  width: 60vw;
  height: 60vh;
}
</style>
